var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

/**
 * Local dependencies
 */
var _require = require('@solid/jose'),
    JWT = _require.JWT;

var IDTokenSchema = require('./IDTokenSchema');
/**
 * IDToken
 */


var IDToken =
/*#__PURE__*/
function (_JWT) {
  "use strict";

  _inherits(IDToken, _JWT);

  function IDToken() {
    _classCallCheck(this, IDToken);

    return _possibleConstructorReturn(this, _getPrototypeOf(IDToken).apply(this, arguments));
  }

  _createClass(IDToken, null, [{
    key: "schema",

    /**
     * Schema
     */
    get: function get() {
      return IDTokenSchema;
    }
  }]);

  return IDToken;
}(JWT);
/**
 * Export
 */


module.exports = IDToken;